export function getClientCapabilities () {
    return {
        screen: {
            height: window.screen.height,
            width: window.screen.width,
            color_depth: window.screen.colorDepth
        },
        java_enabled: window.navigator.javaEnabled(),
        timezone_offset: new Date().getTimezoneOffset(),
        apple_pay: {
            can_make_payments: false
            // window.ApplePaySession && window.ApplePaySession.canMakePayments()
            // ? true
            // : false
        }
    };
}

export const currencyFormat = (value, currency, language) => {
    if (value === null) return null;
    const valueWithCentsAsDecimals = (value / 100).toFixed(2);
    return new Intl.NumberFormat(
        language,
        { style: 'currency', currency: currency },
    ).format(valueWithCentsAsDecimals);
};
